import React from "react";
import { Box, Skeleton } from "@mui/material";

const TicketLoading = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Box sx={{ width: "100%" }}>
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <Skeleton
            variant="rectangular"
            width={88}
            height={26}
            sx={{ mb: 2 }}
          />
        </Box>

        {/* admin messages */}
        <Box sx={{ width: "100%" }}>
          {/* first message */}
          <Box sx={{ display: "flex", justifyContent: "end" }}>
            <Box>
              <Skeleton
                variant="rectangular"
                width={128}
                height={45}
                sx={{ borderRadius: "20px 5px 20px 20px", mr: 2 }}
              />
              <Skeleton
                variant="rectangular"
                width={60}
                height={14}
                sx={{ mt: 0.5 }}
              />
            </Box>
            <Skeleton variant="rectangular" width={36} height={36} />
          </Box>

          {/* second message with file */}
          <Box sx={{ display: "flex", justifyContent: "end", mt: 2 }}>
            <Box>
              <Skeleton
                variant="rectangular"
                width={224}
                height={113}
                sx={{ borderRadius: "20px 5px 20px 20px", mr: 2 }}
              />
              <Skeleton
                variant="rectangular"
                width={60}
                height={14}
                sx={{ mt: 0.5 }}
              />
            </Box>
            <Skeleton variant="rectangular" width={36} height={36} />
          </Box>
        </Box>

        {/* user messages */}
        <Box sx={{ width: "100%" }}>
          {/* first message */}

          {/* first message with file */}
          <Box sx={{ display: "flex", justifyContent: "start", mt: 2 }}>
            <Skeleton variant="rectangular" width={36} height={36} />
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "end",
              }}
            >
              <Skeleton
                variant="rectangular"
                sx={{
                  width: { xs: 128, md: 324 },
                  height: { xs: 45, md: 83 },
                  borderRadius: "5px 20px 20px 20px",
                  ml: 2,
                }}
              />
              <Skeleton
                variant="rectangular"
                width={60}
                height={14}
                sx={{ mt: 0.5 }}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {/* input */}
      <Skeleton variant="rectangular" height={64} />
    </Box>
  );
};

export default TicketLoading;
